export default {
  name: "Pria Prabhu",
  feedback: `The best place for beginners to learn baking..My baking journey starts here..
  Ramya mam is such a friendly mentor who guide us always..
  it's been more than 7 years but still if I have any doubt in my baking means she will clarify without any hesitation.. 
  Strongly recommend salem cake craft studio to anyone who loves baking ...Sure u will see the miracle in u..`
};
